import { emailSuggestorUtils } from 'shared/utils/email_suggestor_utils';

export function mountDataPrivacyLanguage({ $signUpForm }) {
  $(() => {
    const $countrySelect = $signUpForm.find('.country-code-input');
    const $dataPrivacyLanguage = $signUpForm.find('.data-privacy-language-container');

    if (!$countrySelect) {
      return;
    }

    $countrySelect.on('change', () => {
      $dataPrivacyLanguage.load(`/users/data_privacy_language/${$countrySelect.val()}`);
    });
  });
}

export function mountEmailSuggestor({ $signUpForm }) {
  const $emailInput = $signUpForm.find('#user_email');
  const $emailSuggestionContainer = $signUpForm.find('.suggested-email');
  const $emailCorrection = $signUpForm.find('.suggested-email-correction');

  emailSuggestorUtils.mountEmailSuggestor($emailInput, $emailSuggestionContainer, $emailCorrection, 'sign up form');
}

export function mountEmailErrorDisplayer({ $signUpForm }) {
  const $emailInput = $signUpForm.find('#user_email');
  const $emailErrorContainer = $signUpForm.find('.email-validation-error');
  const $emailErrorMessage = $signUpForm.find('.email-validation-error-message');

  $emailInput.on('blur', () => {
    if ($emailInput.is(':invalid') && $emailInput.val()) {
      $emailErrorContainer.addClass('has-error');
      $emailErrorMessage.text('Please enter a valid email address.');
      $emailErrorMessage.attr('aria-label', 'Error: please enter a valid email address.');
      $emailErrorMessage.focus();
    }

    if ($emailInput.is(':valid')) {
      $emailErrorContainer.removeClass('has-error');
      $emailErrorMessage.text('');
      $emailErrorMessage.removeAttr('aria-label');
    }
  });
}

export function preventDoubleSignupSubmit({ $signUpForm }) {
  $(() => {
    $($signUpForm).on('submit', () => {
      const $chirpSubmitButton = $signUpForm.find('.chirp-submit-button')[0];
      $chirpSubmitButton.disabled = true;
    });
  });
}
